export const checkIsClientSide = () => typeof window !== 'undefined';
